// // import React, { useState } from "react";

// // export const FormSelect = ({ colStyle, label, updateField, validators = [], ...props }) => {

// //     const [isValid, setIsValid] = useState(true);
// //     const [errorMessage, setErrorMessage] = useState("");

// //     const handleChange = (e) => {
// //         const value = e.target.value;
// //         let valid = true;
// //         let error = "";

// //         // Verificar se a opção "Selecione uma opção" foi escolhida
// //         if (value === "") {
// //             valid = false;
// //             error = "Por favor, selecione uma opção válida.";
// //         } else if (validators && validators.length > 0) {
// //             // Validação personalizada, se fornecida
// //             for (const validator of validators) {
// //                 const validation = validator.func(value, validator.argument);
// //                 if (!validation.valid) {
// //                     valid = false;
// //                     error = validation.message;
// //                     break;
// //                 }
// //             }
// //         }

// //         setIsValid(valid);  // Atualiza o estado de validação
// //         setErrorMessage(error);

// //         // Chama updateField se existir
// //         if (updateField) {
// //             updateField(props.id, valid);  // Passa o id do campo e a validação
// //         }

// //         // Outra lógica de change, se necessário...
// //     };

// //     return (
// //         <span className='form-col' style={colStyle}>
// //             <label className='form-label' htmlFor={props.id}>{label}</label>
// //             <div className='form-container' style={props.style}>
// //                 <select {...props} name={props.id} onChange={handleChange}>
// //                     {props.children}
// //                 </select>
// //             </div>
// //             {!isValid && <span className="form-message">{errorMessage}</span>} {/* Exibe a mensagem de erro */}
// //         </span>
// //     )
// // }

// import React, { useState } from "react";

// export const FormSelect = ({ colStyle, label, updateField, validators = [], children, defaultValue = "", ...props }) => {
//     const [value, setValue] = useState(defaultValue);  // Valor selecionado controlado pelo estado
//     const [isValid, setIsValid] = useState(true);  // Controle de validação

//     const handleChange = (e) => {
//         const selectedValue = e.target.value;
//         setValue(selectedValue);  // Atualiza o valor do select

//         let valid = true;
//         let errorMessage = "";

//         // Validação de obrigatoriedade (se passar validadores)
//         if (validators && validators.length > 0) {
//             for (const validator of validators) {
//                 const validation = validator.func(selectedValue, validator.argument);
//                 if (!validation.valid) {
//                     valid = false;
//                     errorMessage = validation.message;
//                     break;
//                 }
//             }
//         }

//         setIsValid(valid);  // Atualiza o estado de validação

//         // Chama updateField se existir
//         if (updateField) {
//             updateField(props.id, valid);  // Passa o id do campo e a validação
//         }
//     };

//     return (
//         <span className='form-col' style={colStyle}>
//             <label className='form-label' htmlFor={props.id}>{label}</label>
//             <div className='form-container' style={props.style}>
//                 <select {...props} name={props.id} value={value} onChange={handleChange}>
//                     <option value="" disabled>{children ? "Selecione uma opção" : "Selecione"}</option> {/* Primeira opção que não pode ser selecionada */}
//                     {children} {/* Filhos (opções) passados para o FormSelect */}
//                 </select>
//             </div>
//         </span>
//     );
// };

import React, { useState, useEffect, useRef } from "react";

export const FormSelect = ({
    colStyle,
    label,
    updateField,
    validators = [],
    children,
    defaultValue = "",
    onChange,
    errorMessage = "Selecione uma opção válida",
    ...props
}) => {
    const [value, setValue] = useState(defaultValue); 
    const [isValid, setIsValid] = useState(true);  
    const [firstClick, setFirstClick] = useState(true);
    const [invalidMessage, setInvalidMessage] = useState('');

    const inputField = useRef(null);

    const handleChange = (e) => {
        const selectedValue = e.target.value;
        setFirstClick(false)

        setIsValid(true);
        setInvalidMessage("");

        if (validators != null && validators.length > 0) {
            for (const validator of validators) {
                let data = { valid: true, message: "" }

                if (validator.argument != null && validator.argument !== undefined)
                    data = validator.func(selectedValue, validator.argument);
                else {
                    data = validator.func(selectedValue);
                }

                if (data.valid === false) {
                    setIsValid(false);
                    setInvalidMessage(data.message)
                    break;
                }
            }
        }
        setValue(selectedValue);

        if (onChange !== undefined) {
            onChange(e);
        }
    };

    useEffect(() => {
            if (inputField?.current !== undefined) {
                if (validators != null && validators.length > 0) {
                    for (const validator of validators) {
                        const data = validator.func(inputField.current.value, validator.argument);
                        if (data.valid === false) {
                            setIsValid(false);
                            setInvalidMessage(data.message)
                            break;
                        }
                    }
                }
            }
        }, [validators])

    useEffect(() => {
        if (updateField != null && updateField !== undefined) updateField(props.id, isValid)
    }, [isValid])

    return (
        <span className={`form-col ${!isValid ? 'error' : ''}`} style={colStyle} data-valid={(!isValid) && (!firstClick) ? "false" : "true"}>
            <label className='form-label' htmlFor={props.id}>{label}</label>
            <div className='form-container' style={props.style}>
                <select ref={inputField} {...props} name={props.id} value={value} onChange={handleChange} onClick={() => {setFirstClick(false)}}>
                    <option value="" disabled>{children ? "Selecione uma opção" : "Selecione"}</option>
                    {children}
                </select>
            </div>
            {(!firstClick && !isValid)&& <span className="form-message"> {invalidMessage} </span>}
        </span>
    );
};
